import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ShareLink from "../Shared/ShareLink";

export default function Blog() {
  const navgate = useNavigate();
  const [data, setData] = useState([]);

  const blogData = () => {
    axios
      .post(
        "https://m1blog.aaragroups.com/blog/store-based-blog-list-api/",
        { store_id: 4 },

        {
          headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        console.log("RESPONSE ==== : ", res.data?.blog_list);
        setData(res.data?.blog_list);
      })
      .catch((err) => {
        console.log("ERROR: ====", err);
        alert(err.response.data.message);
      });
  };
  useEffect(() => {
    blogData();
  }, []);
  return (
    <>
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Blog</title>
          <link rel="canonical" href="http://mysite.com/example" />
        </Helmet>
      </div>
      <div className="p-8 lg:px-28 px-5 lg:pb-16 pb-5  pt-40 hm">
        <div className="flex flex-col lg:py-6 py-3 justify-center items-center gap-2">
          <p className="lg:text-5xl text-3xl font-bold p-3 text-white">Blogs</p>
          <p className="lg:text-3xl text-xl font-light text-white">
            Our Few Blogs are Presented Here
          </p>
        </div>
        <div className="lg:flex-row flex flex-col gap-12">
          <div className="lg:w-2/3 w-full flex flex-col gap-4 corser=">
            {data?.map((item) => {
              return (
                <div className="lg:flex-row flex flex-col gap-4 p-4 shadow-xl rounded-lg border">
                  <span>
                    <img
                      src={item.images}
                      className="lg:w-56 lg:h-36 w-full h-full"
                      alt=""
                    />
                    <ShareLink
                      url={window.location.href}
                      variantImage={item.images}
                      variantName={item.Title}
                    />
                  </span>

                  <div>
                    <div className="flex gap-2 mt-1">
                      <p className="text-base bg-violet-600 text-white p-1 px-2 rounded">
                        {item.category}
                      </p>
                      <p className="text-base bg-violet-600 text-white p-1 px-2 rounded">
                        {item.publish_date}
                      </p>
                    </div>
                    <p className="font-semibold text-base py-1 text-white">
                      {item.meta_title}
                    </p>
                    <p className="text-sm text-white">{item.sub_title}</p>
                    <p
                      onClick={() =>
                        navgate(`/blogdetail/${item.id}/${item.slug}`)
                      }
                      className="text-sm font-semibold text-orange-500 pt-1"
                    >
                      Read More...
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="lg:w-1/3 w-full shadow-lg p-4 border rounded-lg">
            <p className="text-2xl font-bold pb-4 text-white">Recent Posts</p>
            <div className="flex flex-col gap-3">
              {data?.map((item) => {
                return (
                  <div className="flex gap-2 shadow-lg">
                    <img src={item.images} className="w-28 h-28 rounded" />
                    <div className="flex flex-col text-white">
                      <p className="font-semibold p-2 text-lg underline">
                        {item.meta_keyword}
                      </p>
                      <p className="text-xs text-blue-700 p-2">
                        {item.publish_date}
                      </p>
                      <p
                        onClick={() =>
                          navgate(`/blogdetail/${item.id}/${item.slug}`)
                        }
                        className="text-sm text-orange-500 underline p-2"
                      >
                        Read More...
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white h-28"></div>
    </>
  );
}
